import Observable from './utils/Observable'

let windowWidth = new Observable(document.body.clientWidth)
let windowHeight = new Observable(innerHeight)
let scrollPos = new Observable($(window).scrollTop())

$(window).resize(() => setTimeout(() => {
  windowWidth.set(document.body.clientWidth)
  windowHeight.set(innerHeight)
}))

$(document).on('scroll', e => {
  e.preventDefault()
  scrollPos.set(window.pageYOffset)
})

let headerHeight = new Observable(55)
scrollPos.watch((value, oldValue) => {
  if (!oldValue) return 55
  setTimeout(() =>
    headerHeight.set(value < oldValue ? 55 : 0)
  )
})

export {
  windowWidth,
  windowHeight,
  scrollPos,
  headerHeight
}